import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ROUTE_MAP = {
  '/dashboard': 'sidebar.dashboard',
  '/crm/contacts': 'sidebar.contacts',
  '/crm/companies': 'sidebar.companies',
  '/crm/lists': 'sidebar.lists',
  '/sequences': 'sidebar.sequences',
  '/inbox': 'sidebar.inbox',
  '/tasks': 'sidebar.tasks',
  '/campaigns': 'sidebar.campaigns',
  '/templates': 'sidebar.templates',
  '/queue': 'sidebar.allEmails',
  '/processing': 'sidebar.processing',
  '/not-sended': 'sidebar.queued',
  '/batch': 'sidebar.batchSend',
  '/suppressions': 'sidebar.blocklist',
  '/upload': 'sidebar.csvUpload',
  '/mail-accounts': 'sidebar.senderAccounts',
  '/sender-pools': 'sidebar.senderPools',
  '/email-finder': 'sidebar.emailFinder',
  '/verified-emails': 'sidebar.verified',
  '/saved-emails': 'sidebar.savedScans',
  '/workflows': 'sidebar.orchestrator',
  '/workflows/runs': 'sidebar.executionConsole',
  '/inbox/automations': 'sidebar.inboxAutomations',
  '/sales-dashboard': 'sidebar.salesDashboard',
  '/success': 'sidebar.customerSuccess',
  '/ops': 'sidebar.opsDashboard',
  '/ops/signals': 'sidebar.signalGovernance',
  '/approvals': 'sidebar.approvals',
  '/plan': 'sidebar.planBilling',
  '/sessions': 'sidebar.activeSessions',
  '/vault': 'sidebar.vaultWebhooks',
  '/reports': 'sidebar.complianceReports',
  '/documentation': 'sidebar.documentation',
  '/settings': 'sidebar.settings',
};

export default function NavBreadcrumb() {
  const location = useLocation();
  const { t } = useTranslation();
  const path = location.pathname;
  const homeRoute = '/dashboard';
  
  // Try to find exact match or dynamic match
  let moduleKey = ROUTE_MAP[path] || '';
  
  // Handle nested/dynamic routes
  if (!moduleKey) {
      if (path.startsWith('/prospect-lists/')) moduleKey = 'nav.listDetail';
      else if (path.startsWith('/sequences/')) moduleKey = 'nav.sequenceEditor';
      else if (path.startsWith('/inbox/')) moduleKey = 'nav.thread';
  }

  if (!moduleKey && path === '/') moduleKey = 'sidebar.dashboard';

  return (
    <div className="flex items-center gap-2 text-sm font-medium">
      <Link
        to={homeRoute}
        aria-label={t('nav.goToDashboard')}
        className="flex items-center gap-1.5 text-muted-foreground/60 rounded-md px-1.5 py-1 -mx-1.5 -my-1 transition-colors hover:text-foreground hover:bg-accent/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30"
      >
        <Home className="h-3.5 w-3.5" />
        <span className="hidden sm:inline">Mailwise</span>
      </Link>
      <ChevronRight className="h-3.5 w-3.5 text-muted-foreground/30" />
      <span className="text-foreground font-semibold tracking-tight">
        {moduleKey ? t(moduleKey) : ''}
      </span>
    </div>
  );
}
